import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "window-title" }, "Duration Alert", -1)
const _hoisted_2 = {
  class: "order-menu-warning flex-col",
  id: "timeWarningMenu"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "flex-col flex-center menu-title" }, "Duration Alert", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "This selection will produce the following errors and will require a manager's passcode at check out.", -1)
const _hoisted_5 = { class: "focus-box flex-col" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "warning-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_time_slot_selector = _resolveComponent("time-slot-selector")!
  const _component_order_menu = _resolveComponent("order-menu")!
  const _component_exp_section_base = _resolveComponent("exp-section-base")!

  return (_openBlock(), _createBlock(_component_exp_section_base, {
    label: 'Time',
    inactive: !_ctx.activeLabel,
    id: "dateTimeSection"
  }, _createSlots({
    summary: _withCtx(() => [
      (_ctx.summary && _ctx.showSummary)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["clickable summary-text", { 'highlight-text': _ctx.selectedTimes.length }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onFocus')))
          }, _toDisplayString(_ctx.summary), 3))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.isActiveSection)
      ? {
          name: "default",
          fn: _withCtx(() => [
            (_ctx.selectedDate)
              ? (_openBlock(), _createBlock(_component_time_slot_selector, {
                  key: 0,
                  selectedDate: _ctx.selectedDate,
                  editRates: _ctx.editRates,
                  onEnableEditRates: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editRates = $event)),
                  onOnTimeSelect: _ctx.handleTimeSelect
                }, null, 8, ["selectedDate", "editRates", "onOnTimeSelect"]))
              : _createCommentVNode("", true),
            (_ctx.warningMsgs.length)
              ? (_openBlock(), _createBlock(_component_order_menu, {
                  key: 1,
                  onOnClose: _ctx.onWarningCancel
                }, _createSlots({
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _hoisted_3,
                      _hoisted_4,
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warningMsgs, (msg, i) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: i,
                            innerHTML: msg
                          }, null, 8, _hoisted_6))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("button", {
                          class: "naked highlight-text",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onWarningCancel && _ctx.onWarningCancel(...args)))
                        }, "Go Back"),
                        _createElementVNode("button", {
                          class: "btn-highlight",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onContinue && _ctx.onContinue(...args)))
                        }, "Continue")
                      ])
                    ])
                  ]),
                  _: 2
                }, [
                  (!_ctx.desktopView)
                    ? {
                        name: "menuHeader",
                        fn: _withCtx(() => [
                          _hoisted_1
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["onOnClose"]))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["inactive"]))
}